import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-dotted-detail",
  "use": "app-icon-arrow-dotted-detail-usage",
  "viewBox": "0 0 151 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 151 16\" id=\"app-icon-arrow-dotted-detail\"><path d=\"M70 5h4v6H0V5h70zm69.5 6H136V5h3.5V0l11 8-11 8v-5zM78 11V5h4v6h-4zm9 0V5h4v6h-4zm8 0V5h4v6h-4zm8 0V5h4v6h-4zm8 0V5h4v6h-4zm8 0V5h4v6h-4zm9 0V5h4v6h-4z\" fill=\"#85A4FA\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol